import { Box, HStack, Skeleton, VStack } from '@chakra-ui/react';
import { FC } from 'react';

export interface SessionPrepCardSkeletonProps {
  /** Number of content skeleton rows to display (default: 2) */
  rows?: number;
  /** Test ID for the skeleton container */
  'data-testid'?: string;
}

/**
 * Shared skeleton loader for session prep cards.
 * Displays a header section (icon + title) followed by content rows.
 * Used by SessionFocusCard, SessionRecapCard, and SessionGoals.
 */
export const SessionPrepCardSkeleton: FC<SessionPrepCardSkeletonProps> = ({
  rows = 2,
  'data-testid': testId,
}) => {
  return (
    <Box data-testid={testId}>
      {/* Header: icon + title */}
      <HStack spacing={2} mb={3}>
        <Skeleton height="16px" width="16px" data-testid="skeleton-loader" />
        <Skeleton height="12px" width="100px" data-testid="skeleton-loader" />
      </HStack>

      {/* Content rows */}
      <VStack spacing={2} align="stretch">
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton
            key={index}
            height="16px"
            width={index === 0 ? '100%' : `${Math.max(60, 100 - index * 10)}%`}
            data-testid="skeleton-loader"
          />
        ))}
      </VStack>
    </Box>
  );
};

SessionPrepCardSkeleton.displayName = 'SessionPrepCardSkeleton';
